import { render, staticRenderFns } from "./BtnExcluirDetalhesFaseEmLote.vue?vue&type=template&id=a12235a0"
import script from "./BtnExcluirDetalhesFaseEmLote.vue?vue&type=script&lang=js"
export * from "./BtnExcluirDetalhesFaseEmLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports